<div class="dialog-header">
  <h2 mat-dialog-title>Preview: {{ data.template.name }}</h2>
  <div class="header-actions">
    <button mat-icon-button (click)="downloadFile()" matTooltip="Download">
      <mat-icon>download</mat-icon>
    </button>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="preview-content">
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  @if (error) {
    <div class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ error }}</p>
    </div>
  }

  <div class="canvas-container" [hidden]="isLoading || error">
    <canvas #pdfCanvas></canvas>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  @if (!isLoading && !error && totalPages > 1) {
    <div class="navigation-bar">
      <button mat-icon-button (click)="prevPage()" [disabled]="currentPage === 1 || isLoading">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <span class="page-counter">Page {{ currentPage }} of {{ totalPages }}</span>

      <button mat-icon-button (click)="nextPage()" [disabled]="currentPage === totalPages || isLoading">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
